
    import I18n from 'i18nObj';
    
      import 'translations/files_upload_progress';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('files_upload_progress');
  